/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../axios';
import { request } from '../../axios';
import type { PaginatedResponse } from '../pagination/pagination.types';
import type {
  CaseClosureChecklistDto,
  CaseManagementDto,
  CreatePatientDto,
  CreateTherapyComplianceDto,
  CreateTherapySupplementDto,
  DirectlyObservedTherapyDto,
  EndDirectlyObservedTherapyDto,
  EndTherapyDTO,
  GetAnamnesesByPatient200,
  GetPatientsBasicsParams,
  MedicationDto,
  PatientAddressDto,
  PatientBasicsDto,
  PatientDto,
  PatientProfilePictureDto,
  TherapyConditionDto,
  TherapyDto,
  TherapyMedicationChangeDto,
  UpdatePatientProfilePictureBody,
  ValidateCaseNumberParams,
  ValidationResult,
} from '.././model';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const getPatientsBasics = (
  params: GetPatientsBasicsParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<PaginatedResponse<PatientDto>>({ url: `/api/patients`, method: 'GET', params, signal }, options);
};

export const getGetPatientsBasicsQueryKey = (params: GetPatientsBasicsParams) => {
  return [`/api/patients`, ...(params ? [params] : [])] as const;
};

export const getGetPatientsBasicsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientsBasics>>,
  TError = ErrorType<unknown>,
>(
  params: GetPatientsBasicsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsBasics>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientsBasicsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsBasics>>> = ({ signal }) =>
    getPatientsBasics(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientsBasics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientsBasicsQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsBasics>>>;
export type GetPatientsBasicsQueryError = ErrorType<unknown>;

export function useGetPatientsBasics<
  TData = Awaited<ReturnType<typeof getPatientsBasics>>,
  TError = ErrorType<unknown>,
>(
  params: GetPatientsBasicsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsBasics>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getPatientsBasics>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientsBasics<
  TData = Awaited<ReturnType<typeof getPatientsBasics>>,
  TError = ErrorType<unknown>,
>(
  params: GetPatientsBasicsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsBasics>>, TError, TData>> &
    Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getPatientsBasics>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientsBasics<
  TData = Awaited<ReturnType<typeof getPatientsBasics>>,
  TError = ErrorType<unknown>,
>(
  params: GetPatientsBasicsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsBasics>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientsBasics<
  TData = Awaited<ReturnType<typeof getPatientsBasics>>,
  TError = ErrorType<unknown>,
>(
  params: GetPatientsBasicsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsBasics>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientsBasicsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPatientsBasicsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientsBasics>>,
  TError = ErrorType<unknown>,
>(
  params: GetPatientsBasicsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsBasics>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientsBasicsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsBasics>>> = ({ signal }) =>
    getPatientsBasics(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPatientsBasics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientsBasicsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsBasics>>>;
export type GetPatientsBasicsSuspenseQueryError = ErrorType<unknown>;

export function useGetPatientsBasicsSuspense<
  TData = Awaited<ReturnType<typeof getPatientsBasics>>,
  TError = ErrorType<unknown>,
>(
  params: GetPatientsBasicsParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsBasics>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientsBasicsSuspense<
  TData = Awaited<ReturnType<typeof getPatientsBasics>>,
  TError = ErrorType<unknown>,
>(
  params: GetPatientsBasicsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsBasics>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientsBasicsSuspense<
  TData = Awaited<ReturnType<typeof getPatientsBasics>>,
  TError = ErrorType<unknown>,
>(
  params: GetPatientsBasicsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsBasics>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientsBasicsSuspense<
  TData = Awaited<ReturnType<typeof getPatientsBasics>>,
  TError = ErrorType<unknown>,
>(
  params: GetPatientsBasicsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsBasics>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientsBasicsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updatePatient = (patientDto: BodyType<PatientDto>, options?: SecondParameter<typeof request>) => {
  return request<PatientDto>(
    { url: `/api/patients`, method: 'PUT', headers: { 'Content-Type': 'application/json' }, data: patientDto },
    options,
  );
};

export const getUpdatePatientMutationOptions = <
  TData = Awaited<ReturnType<typeof updatePatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<PatientDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updatePatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePatient>>, { data: BodyType<PatientDto> }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return updatePatient(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BodyType<PatientDto> },
    TContext
  >;
};

export type UpdatePatientMutationResult = NonNullable<Awaited<ReturnType<typeof updatePatient>>>;
export type UpdatePatientMutationBody = BodyType<PatientDto>;
export type UpdatePatientMutationError = ErrorType<unknown>;

export const useUpdatePatient = <
  TData = Awaited<ReturnType<typeof updatePatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<PatientDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { data: BodyType<PatientDto> }, TContext> => {
  const mutationOptions = getUpdatePatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createPatient = (
  createPatientDto: BodyType<CreatePatientDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/patients`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createPatientDto,
      signal,
    },
    options,
  );
};

export const getCreatePatientMutationOptions = <
  TData = Awaited<ReturnType<typeof createPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreatePatientDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPatient>>,
    { data: BodyType<CreatePatientDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createPatient(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BodyType<CreatePatientDto> },
    TContext
  >;
};

export type CreatePatientMutationResult = NonNullable<Awaited<ReturnType<typeof createPatient>>>;
export type CreatePatientMutationBody = BodyType<CreatePatientDto>;
export type CreatePatientMutationError = ErrorType<unknown>;

export const useCreatePatient = <
  TData = Awaited<ReturnType<typeof createPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreatePatientDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { data: BodyType<CreatePatientDto> }, TContext> => {
  const mutationOptions = getCreatePatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getTherapyByPatient = (id: string, options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<TherapyDto>({ url: `/api/patients/${id}/therapy`, method: 'GET', signal }, options);
};

export const getGetTherapyByPatientQueryKey = (id: string) => {
  return [`/api/patients/${id}/therapy`] as const;
};

export const getGetTherapyByPatientQueryOptions = <
  TData = Awaited<ReturnType<typeof getTherapyByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTherapyByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTherapyByPatientQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTherapyByPatient>>> = ({ signal }) =>
    getTherapyByPatient(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTherapyByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTherapyByPatientQueryResult = NonNullable<Awaited<ReturnType<typeof getTherapyByPatient>>>;
export type GetTherapyByPatientQueryError = ErrorType<unknown>;

export function useGetTherapyByPatient<
  TData = Awaited<ReturnType<typeof getTherapyByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTherapyByPatient>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getTherapyByPatient>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTherapyByPatient<
  TData = Awaited<ReturnType<typeof getTherapyByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTherapyByPatient>>, TError, TData>> &
    Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getTherapyByPatient>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTherapyByPatient<
  TData = Awaited<ReturnType<typeof getTherapyByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTherapyByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTherapyByPatient<
  TData = Awaited<ReturnType<typeof getTherapyByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTherapyByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTherapyByPatientQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetTherapyByPatientSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getTherapyByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTherapyByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTherapyByPatientQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTherapyByPatient>>> = ({ signal }) =>
    getTherapyByPatient(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getTherapyByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTherapyByPatientSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTherapyByPatient>>>;
export type GetTherapyByPatientSuspenseQueryError = ErrorType<unknown>;

export function useGetTherapyByPatientSuspense<
  TData = Awaited<ReturnType<typeof getTherapyByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTherapyByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTherapyByPatientSuspense<
  TData = Awaited<ReturnType<typeof getTherapyByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTherapyByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTherapyByPatientSuspense<
  TData = Awaited<ReturnType<typeof getTherapyByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTherapyByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTherapyByPatientSuspense<
  TData = Awaited<ReturnType<typeof getTherapyByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTherapyByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTherapyByPatientSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateTherapyByPatient = (
  id: string,
  therapyDto: BodyType<TherapyDto>,
  options?: SecondParameter<typeof request>,
) => {
  return request<void>(
    {
      url: `/api/patients/${id}/therapy`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: therapyDto,
    },
    options,
  );
};

export const getUpdateTherapyByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof updateTherapyByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<TherapyDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updateTherapyByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTherapyByPatient>>,
    { id: string; data: BodyType<TherapyDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTherapyByPatient(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<TherapyDto> },
    TContext
  >;
};

export type UpdateTherapyByPatientMutationResult = NonNullable<Awaited<ReturnType<typeof updateTherapyByPatient>>>;
export type UpdateTherapyByPatientMutationBody = BodyType<TherapyDto>;
export type UpdateTherapyByPatientMutationError = ErrorType<unknown>;

export const useUpdateTherapyByPatient = <
  TData = Awaited<ReturnType<typeof updateTherapyByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<TherapyDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<TherapyDto> }, TContext> => {
  const mutationOptions = getUpdateTherapyByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createTherapyByPatient = (
  id: string,
  therapyDto: BodyType<TherapyDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/patients/${id}/therapy`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: therapyDto,
      signal,
    },
    options,
  );
};

export const getCreateTherapyByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof createTherapyByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<TherapyDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createTherapyByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTherapyByPatient>>,
    { id: string; data: BodyType<TherapyDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createTherapyByPatient(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<TherapyDto> },
    TContext
  >;
};

export type CreateTherapyByPatientMutationResult = NonNullable<Awaited<ReturnType<typeof createTherapyByPatient>>>;
export type CreateTherapyByPatientMutationBody = BodyType<TherapyDto>;
export type CreateTherapyByPatientMutationError = ErrorType<unknown>;

export const useCreateTherapyByPatient = <
  TData = Awaited<ReturnType<typeof createTherapyByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<TherapyDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<TherapyDto> }, TContext> => {
  const mutationOptions = getCreateTherapyByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updateTherapyPhaseMedicationByPatient = (
  id: string,
  phase: 'PHASE_1' | 'PHASE_2',
  medicationDto: BodyType<MedicationDto[]>,
  options?: SecondParameter<typeof request>,
) => {
  return request<void>(
    {
      url: `/api/patients/${id}/therapy/${phase}/medication`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: medicationDto,
    },
    options,
  );
};

export const getUpdateTherapyPhaseMedicationByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof updateTherapyPhaseMedicationByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { id: string; phase: 'PHASE_1' | 'PHASE_2'; data: BodyType<MedicationDto[]> },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updateTherapyPhaseMedicationByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTherapyPhaseMedicationByPatient>>,
    { id: string; phase: 'PHASE_1' | 'PHASE_2'; data: BodyType<MedicationDto[]> }
  > = (props) => {
    const { id, phase, data } = props ?? {};

    return updateTherapyPhaseMedicationByPatient(id, phase, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; phase: 'PHASE_1' | 'PHASE_2'; data: BodyType<MedicationDto[]> },
    TContext
  >;
};

export type UpdateTherapyPhaseMedicationByPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTherapyPhaseMedicationByPatient>>
>;
export type UpdateTherapyPhaseMedicationByPatientMutationBody = BodyType<MedicationDto[]>;
export type UpdateTherapyPhaseMedicationByPatientMutationError = ErrorType<unknown>;

export const useUpdateTherapyPhaseMedicationByPatient = <
  TData = Awaited<ReturnType<typeof updateTherapyPhaseMedicationByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { id: string; phase: 'PHASE_1' | 'PHASE_2'; data: BodyType<MedicationDto[]> },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<
  TData,
  TError,
  { id: string; phase: 'PHASE_1' | 'PHASE_2'; data: BodyType<MedicationDto[]> },
  TContext
> => {
  const mutationOptions = getUpdateTherapyPhaseMedicationByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getCaseManagementByPatientId = (
  id: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<CaseManagementDto>({ url: `/api/patients/${id}/case-management`, method: 'GET', signal }, options);
};

export const getGetCaseManagementByPatientIdQueryKey = (id: string) => {
  return [`/api/patients/${id}/case-management`] as const;
};

export const getGetCaseManagementByPatientIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCaseManagementByPatientId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseManagementByPatientId>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCaseManagementByPatientIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCaseManagementByPatientId>>> = ({ signal }) =>
    getCaseManagementByPatientId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCaseManagementByPatientId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCaseManagementByPatientIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCaseManagementByPatientId>>
>;
export type GetCaseManagementByPatientIdQueryError = ErrorType<unknown>;

export function useGetCaseManagementByPatientId<
  TData = Awaited<ReturnType<typeof getCaseManagementByPatientId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseManagementByPatientId>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof getCaseManagementByPatientId>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCaseManagementByPatientId<
  TData = Awaited<ReturnType<typeof getCaseManagementByPatientId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseManagementByPatientId>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof getCaseManagementByPatientId>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCaseManagementByPatientId<
  TData = Awaited<ReturnType<typeof getCaseManagementByPatientId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseManagementByPatientId>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetCaseManagementByPatientId<
  TData = Awaited<ReturnType<typeof getCaseManagementByPatientId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseManagementByPatientId>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCaseManagementByPatientIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCaseManagementByPatientIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getCaseManagementByPatientId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCaseManagementByPatientId>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCaseManagementByPatientIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCaseManagementByPatientId>>> = ({ signal }) =>
    getCaseManagementByPatientId(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getCaseManagementByPatientId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCaseManagementByPatientIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCaseManagementByPatientId>>
>;
export type GetCaseManagementByPatientIdSuspenseQueryError = ErrorType<unknown>;

export function useGetCaseManagementByPatientIdSuspense<
  TData = Awaited<ReturnType<typeof getCaseManagementByPatientId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCaseManagementByPatientId>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCaseManagementByPatientIdSuspense<
  TData = Awaited<ReturnType<typeof getCaseManagementByPatientId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCaseManagementByPatientId>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCaseManagementByPatientIdSuspense<
  TData = Awaited<ReturnType<typeof getCaseManagementByPatientId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCaseManagementByPatientId>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetCaseManagementByPatientIdSuspense<
  TData = Awaited<ReturnType<typeof getCaseManagementByPatientId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCaseManagementByPatientId>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCaseManagementByPatientIdSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateCaseManagementByPatientId = (
  id: string,
  caseManagementDto: BodyType<CaseManagementDto>,
  options?: SecondParameter<typeof request>,
) => {
  return request<CaseManagementDto>(
    {
      url: `/api/patients/${id}/case-management`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: caseManagementDto,
    },
    options,
  );
};

export const getUpdateCaseManagementByPatientIdMutationOptions = <
  TData = Awaited<ReturnType<typeof updateCaseManagementByPatientId>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CaseManagementDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updateCaseManagementByPatientId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCaseManagementByPatientId>>,
    { id: string; data: BodyType<CaseManagementDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCaseManagementByPatientId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<CaseManagementDto> },
    TContext
  >;
};

export type UpdateCaseManagementByPatientIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCaseManagementByPatientId>>
>;
export type UpdateCaseManagementByPatientIdMutationBody = BodyType<CaseManagementDto>;
export type UpdateCaseManagementByPatientIdMutationError = ErrorType<unknown>;

export const useUpdateCaseManagementByPatientId = <
  TData = Awaited<ReturnType<typeof updateCaseManagementByPatientId>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CaseManagementDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<CaseManagementDto> }, TContext> => {
  const mutationOptions = getUpdateCaseManagementByPatientIdMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getCaseClosureChecklist = (
  id: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<CaseClosureChecklistDto>(
    { url: `/api/patients/${id}/case-management/closure-checklist`, method: 'GET', signal },
    options,
  );
};

export const getGetCaseClosureChecklistQueryKey = (id: string) => {
  return [`/api/patients/${id}/case-management/closure-checklist`] as const;
};

export const getGetCaseClosureChecklistQueryOptions = <
  TData = Awaited<ReturnType<typeof getCaseClosureChecklist>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseClosureChecklist>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCaseClosureChecklistQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCaseClosureChecklist>>> = ({ signal }) =>
    getCaseClosureChecklist(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCaseClosureChecklist>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCaseClosureChecklistQueryResult = NonNullable<Awaited<ReturnType<typeof getCaseClosureChecklist>>>;
export type GetCaseClosureChecklistQueryError = ErrorType<unknown>;

export function useGetCaseClosureChecklist<
  TData = Awaited<ReturnType<typeof getCaseClosureChecklist>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseClosureChecklist>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCaseClosureChecklistQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const endDirectlyObservedTherapy = (
  endDirectlyObservedTherapyDto: BodyType<EndDirectlyObservedTherapyDto>,
  options?: SecondParameter<typeof request>,
) => {
  return request<void>(
    {
      url: `/api/patients/therapy/directly-observed-therapy/end`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: endDirectlyObservedTherapyDto,
    },
    options,
  );
};

export const getEndDirectlyObservedTherapyMutationOptions = <
  TData = Awaited<ReturnType<typeof endDirectlyObservedTherapy>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<EndDirectlyObservedTherapyDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['endDirectlyObservedTherapy'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof endDirectlyObservedTherapy>>,
    { data: BodyType<EndDirectlyObservedTherapyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return endDirectlyObservedTherapy(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BodyType<EndDirectlyObservedTherapyDto> },
    TContext
  >;
};

export type EndDirectlyObservedTherapyMutationResult = NonNullable<
  Awaited<ReturnType<typeof endDirectlyObservedTherapy>>
>;
export type EndDirectlyObservedTherapyMutationBody = BodyType<EndDirectlyObservedTherapyDto>;
export type EndDirectlyObservedTherapyMutationError = ErrorType<unknown>;

export const useEndDirectlyObservedTherapy = <
  TData = Awaited<ReturnType<typeof endDirectlyObservedTherapy>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<EndDirectlyObservedTherapyDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { data: BodyType<EndDirectlyObservedTherapyDto> }, TContext> => {
  const mutationOptions = getEndDirectlyObservedTherapyMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createTherapySupplementByPatient = (
  id: string,
  createTherapySupplementDto: BodyType<CreateTherapySupplementDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/api/patients/${id}/therapy/supplement`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createTherapySupplementDto,
      signal,
    },
    options,
  );
};

export const getCreateTherapySupplementByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof createTherapySupplementByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateTherapySupplementDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createTherapySupplementByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTherapySupplementByPatient>>,
    { id: string; data: BodyType<CreateTherapySupplementDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createTherapySupplementByPatient(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<CreateTherapySupplementDto> },
    TContext
  >;
};

export type CreateTherapySupplementByPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTherapySupplementByPatient>>
>;
export type CreateTherapySupplementByPatientMutationBody = BodyType<CreateTherapySupplementDto>;
export type CreateTherapySupplementByPatientMutationError = ErrorType<unknown>;

export const useCreateTherapySupplementByPatient = <
  TData = Awaited<ReturnType<typeof createTherapySupplementByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateTherapySupplementDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<CreateTherapySupplementDto> }, TContext> => {
  const mutationOptions = getCreateTherapySupplementByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createTherapyPhase2ByPatient = (
  id: string,
  therapyDto: BodyType<TherapyDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/api/patients/${id}/therapy/phase2`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: therapyDto,
      signal,
    },
    options,
  );
};

export const getCreateTherapyPhase2ByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof createTherapyPhase2ByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<TherapyDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createTherapyPhase2ByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTherapyPhase2ByPatient>>,
    { id: string; data: BodyType<TherapyDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createTherapyPhase2ByPatient(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<TherapyDto> },
    TContext
  >;
};

export type CreateTherapyPhase2ByPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTherapyPhase2ByPatient>>
>;
export type CreateTherapyPhase2ByPatientMutationBody = BodyType<TherapyDto>;
export type CreateTherapyPhase2ByPatientMutationError = ErrorType<unknown>;

export const useCreateTherapyPhase2ByPatient = <
  TData = Awaited<ReturnType<typeof createTherapyPhase2ByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<TherapyDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<TherapyDto> }, TContext> => {
  const mutationOptions = getCreateTherapyPhase2ByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const endTherapyByPatient = (
  id: string,
  endTherapyDTO: BodyType<EndTherapyDTO>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/api/patients/${id}/therapy/end`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: endTherapyDTO,
      signal,
    },
    options,
  );
};

export const getEndTherapyByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof endTherapyByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<EndTherapyDTO> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['endTherapyByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof endTherapyByPatient>>,
    { id: string; data: BodyType<EndTherapyDTO> }
  > = (props) => {
    const { id, data } = props ?? {};

    return endTherapyByPatient(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<EndTherapyDTO> },
    TContext
  >;
};

export type EndTherapyByPatientMutationResult = NonNullable<Awaited<ReturnType<typeof endTherapyByPatient>>>;
export type EndTherapyByPatientMutationBody = BodyType<EndTherapyDTO>;
export type EndTherapyByPatientMutationError = ErrorType<unknown>;

export const useEndTherapyByPatient = <
  TData = Awaited<ReturnType<typeof endTherapyByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<EndTherapyDTO> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<EndTherapyDTO> }, TContext> => {
  const mutationOptions = getEndTherapyByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createDirectlyObservedTherapyByPatient = (
  id: string,
  directlyObservedTherapyDto: BodyType<DirectlyObservedTherapyDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/api/patients/${id}/therapy/directly-observed-therapy`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: directlyObservedTherapyDto,
      signal,
    },
    options,
  );
};

export const getCreateDirectlyObservedTherapyByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof createDirectlyObservedTherapyByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<DirectlyObservedTherapyDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createDirectlyObservedTherapyByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDirectlyObservedTherapyByPatient>>,
    { id: string; data: BodyType<DirectlyObservedTherapyDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createDirectlyObservedTherapyByPatient(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<DirectlyObservedTherapyDto> },
    TContext
  >;
};

export type CreateDirectlyObservedTherapyByPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDirectlyObservedTherapyByPatient>>
>;
export type CreateDirectlyObservedTherapyByPatientMutationBody = BodyType<DirectlyObservedTherapyDto>;
export type CreateDirectlyObservedTherapyByPatientMutationError = ErrorType<unknown>;

export const useCreateDirectlyObservedTherapyByPatient = <
  TData = Awaited<ReturnType<typeof createDirectlyObservedTherapyByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<DirectlyObservedTherapyDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<DirectlyObservedTherapyDto> }, TContext> => {
  const mutationOptions = getCreateDirectlyObservedTherapyByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createTherapyConditionByPatient = (
  id: string,
  therapyConditionDto: BodyType<TherapyConditionDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/api/patients/${id}/therapy/condition`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: therapyConditionDto,
      signal,
    },
    options,
  );
};

export const getCreateTherapyConditionByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof createTherapyConditionByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<TherapyConditionDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createTherapyConditionByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTherapyConditionByPatient>>,
    { id: string; data: BodyType<TherapyConditionDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createTherapyConditionByPatient(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<TherapyConditionDto> },
    TContext
  >;
};

export type CreateTherapyConditionByPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTherapyConditionByPatient>>
>;
export type CreateTherapyConditionByPatientMutationBody = BodyType<TherapyConditionDto>;
export type CreateTherapyConditionByPatientMutationError = ErrorType<unknown>;

export const useCreateTherapyConditionByPatient = <
  TData = Awaited<ReturnType<typeof createTherapyConditionByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<TherapyConditionDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<TherapyConditionDto> }, TContext> => {
  const mutationOptions = getCreateTherapyConditionByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createTherapyComplianceByPatient = (
  id: string,
  createTherapyComplianceDto: BodyType<CreateTherapyComplianceDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/api/patients/${id}/therapy/compliance`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createTherapyComplianceDto,
      signal,
    },
    options,
  );
};

export const getCreateTherapyComplianceByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof createTherapyComplianceByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateTherapyComplianceDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createTherapyComplianceByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTherapyComplianceByPatient>>,
    { id: string; data: BodyType<CreateTherapyComplianceDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createTherapyComplianceByPatient(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<CreateTherapyComplianceDto> },
    TContext
  >;
};

export type CreateTherapyComplianceByPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTherapyComplianceByPatient>>
>;
export type CreateTherapyComplianceByPatientMutationBody = BodyType<CreateTherapyComplianceDto>;
export type CreateTherapyComplianceByPatientMutationError = ErrorType<unknown>;

export const useCreateTherapyComplianceByPatient = <
  TData = Awaited<ReturnType<typeof createTherapyComplianceByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateTherapyComplianceDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<CreateTherapyComplianceDto> }, TContext> => {
  const mutationOptions = getCreateTherapyComplianceByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getPatientProfilePicture = (
  id: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<PatientProfilePictureDto>(
    { url: `/api/patients/${id}/profile-picture`, method: 'GET', signal },
    options,
  );
};

export const getGetPatientProfilePictureQueryKey = (id: string) => {
  return [`/api/patients/${id}/profile-picture`] as const;
};

export const getGetPatientProfilePictureQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientProfilePicture>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientProfilePicture>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientProfilePictureQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientProfilePicture>>> = ({ signal }) =>
    getPatientProfilePicture(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientProfilePicture>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientProfilePictureQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientProfilePicture>>>;
export type GetPatientProfilePictureQueryError = ErrorType<unknown>;

export function useGetPatientProfilePicture<
  TData = Awaited<ReturnType<typeof getPatientProfilePicture>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientProfilePicture>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof getPatientProfilePicture>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientProfilePicture<
  TData = Awaited<ReturnType<typeof getPatientProfilePicture>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientProfilePicture>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof getPatientProfilePicture>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientProfilePicture<
  TData = Awaited<ReturnType<typeof getPatientProfilePicture>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientProfilePicture>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientProfilePicture<
  TData = Awaited<ReturnType<typeof getPatientProfilePicture>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientProfilePicture>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientProfilePictureQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPatientProfilePictureSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientProfilePicture>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientProfilePicture>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientProfilePictureQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientProfilePicture>>> = ({ signal }) =>
    getPatientProfilePicture(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPatientProfilePicture>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientProfilePictureSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientProfilePicture>>
>;
export type GetPatientProfilePictureSuspenseQueryError = ErrorType<unknown>;

export function useGetPatientProfilePictureSuspense<
  TData = Awaited<ReturnType<typeof getPatientProfilePicture>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientProfilePicture>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientProfilePictureSuspense<
  TData = Awaited<ReturnType<typeof getPatientProfilePicture>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientProfilePicture>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientProfilePictureSuspense<
  TData = Awaited<ReturnType<typeof getPatientProfilePicture>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientProfilePicture>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientProfilePictureSuspense<
  TData = Awaited<ReturnType<typeof getPatientProfilePicture>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientProfilePicture>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientProfilePictureSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updatePatientProfilePicture = (
  id: string,
  updatePatientProfilePictureBody: BodyType<UpdatePatientProfilePictureBody>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append('file', updatePatientProfilePictureBody.file);

  return request<void>(
    {
      url: `/api/patients/${id}/profile-picture`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getUpdatePatientProfilePictureMutationOptions = <
  TData = Awaited<ReturnType<typeof updatePatientProfilePicture>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<UpdatePatientProfilePictureBody> },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updatePatientProfilePicture'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePatientProfilePicture>>,
    { id: string; data: BodyType<UpdatePatientProfilePictureBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePatientProfilePicture(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<UpdatePatientProfilePictureBody> },
    TContext
  >;
};

export type UpdatePatientProfilePictureMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePatientProfilePicture>>
>;
export type UpdatePatientProfilePictureMutationBody = BodyType<UpdatePatientProfilePictureBody>;
export type UpdatePatientProfilePictureMutationError = ErrorType<unknown>;

export const useUpdatePatientProfilePicture = <
  TData = Awaited<ReturnType<typeof updatePatientProfilePicture>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<UpdatePatientProfilePictureBody> },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<UpdatePatientProfilePictureBody> }, TContext> => {
  const mutationOptions = getUpdatePatientProfilePictureMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getIsolationByPatient = (id: string, options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<PatientAddressDto>({ url: `/api/patients/${id}/isolation`, method: 'GET', signal }, options);
};

export const getGetIsolationByPatientQueryKey = (id: string) => {
  return [`/api/patients/${id}/isolation`] as const;
};

export const getGetIsolationByPatientQueryOptions = <
  TData = Awaited<ReturnType<typeof getIsolationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIsolationByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIsolationByPatientQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIsolationByPatient>>> = ({ signal }) =>
    getIsolationByPatient(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getIsolationByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIsolationByPatientQueryResult = NonNullable<Awaited<ReturnType<typeof getIsolationByPatient>>>;
export type GetIsolationByPatientQueryError = ErrorType<unknown>;

export function useGetIsolationByPatient<
  TData = Awaited<ReturnType<typeof getIsolationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIsolationByPatient>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getIsolationByPatient>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIsolationByPatient<
  TData = Awaited<ReturnType<typeof getIsolationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIsolationByPatient>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof getIsolationByPatient>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIsolationByPatient<
  TData = Awaited<ReturnType<typeof getIsolationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIsolationByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetIsolationByPatient<
  TData = Awaited<ReturnType<typeof getIsolationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIsolationByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetIsolationByPatientQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetIsolationByPatientSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getIsolationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIsolationByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIsolationByPatientQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIsolationByPatient>>> = ({ signal }) =>
    getIsolationByPatient(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getIsolationByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIsolationByPatientSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getIsolationByPatient>>>;
export type GetIsolationByPatientSuspenseQueryError = ErrorType<unknown>;

export function useGetIsolationByPatientSuspense<
  TData = Awaited<ReturnType<typeof getIsolationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIsolationByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIsolationByPatientSuspense<
  TData = Awaited<ReturnType<typeof getIsolationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIsolationByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIsolationByPatientSuspense<
  TData = Awaited<ReturnType<typeof getIsolationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIsolationByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetIsolationByPatientSuspense<
  TData = Awaited<ReturnType<typeof getIsolationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIsolationByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetIsolationByPatientSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createIsolationByPatient = (
  id: string,
  patientAddressDto: BodyType<PatientAddressDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/patients/${id}/isolation`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: patientAddressDto,
      signal,
    },
    options,
  );
};

export const getCreateIsolationByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof createIsolationByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<PatientAddressDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createIsolationByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createIsolationByPatient>>,
    { id: string; data: BodyType<PatientAddressDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createIsolationByPatient(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<PatientAddressDto> },
    TContext
  >;
};

export type CreateIsolationByPatientMutationResult = NonNullable<Awaited<ReturnType<typeof createIsolationByPatient>>>;
export type CreateIsolationByPatientMutationBody = BodyType<PatientAddressDto>;
export type CreateIsolationByPatientMutationError = ErrorType<unknown>;

export const useCreateIsolationByPatient = <
  TData = Awaited<ReturnType<typeof createIsolationByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<PatientAddressDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<PatientAddressDto> }, TContext> => {
  const mutationOptions = getCreateIsolationByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getHospitalizationByPatient = (
  id: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<PatientAddressDto>({ url: `/api/patients/${id}/hospitalization`, method: 'GET', signal }, options);
};

export const getGetHospitalizationByPatientQueryKey = (id: string) => {
  return [`/api/patients/${id}/hospitalization`] as const;
};

export const getGetHospitalizationByPatientQueryOptions = <
  TData = Awaited<ReturnType<typeof getHospitalizationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalizationByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHospitalizationByPatientQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHospitalizationByPatient>>> = ({ signal }) =>
    getHospitalizationByPatient(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHospitalizationByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHospitalizationByPatientQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHospitalizationByPatient>>
>;
export type GetHospitalizationByPatientQueryError = ErrorType<unknown>;

export function useGetHospitalizationByPatient<
  TData = Awaited<ReturnType<typeof getHospitalizationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalizationByPatient>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof getHospitalizationByPatient>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHospitalizationByPatient<
  TData = Awaited<ReturnType<typeof getHospitalizationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalizationByPatient>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof getHospitalizationByPatient>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHospitalizationByPatient<
  TData = Awaited<ReturnType<typeof getHospitalizationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalizationByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetHospitalizationByPatient<
  TData = Awaited<ReturnType<typeof getHospitalizationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalizationByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHospitalizationByPatientQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetHospitalizationByPatientSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getHospitalizationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHospitalizationByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHospitalizationByPatientQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHospitalizationByPatient>>> = ({ signal }) =>
    getHospitalizationByPatient(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getHospitalizationByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHospitalizationByPatientSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHospitalizationByPatient>>
>;
export type GetHospitalizationByPatientSuspenseQueryError = ErrorType<unknown>;

export function useGetHospitalizationByPatientSuspense<
  TData = Awaited<ReturnType<typeof getHospitalizationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHospitalizationByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHospitalizationByPatientSuspense<
  TData = Awaited<ReturnType<typeof getHospitalizationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHospitalizationByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHospitalizationByPatientSuspense<
  TData = Awaited<ReturnType<typeof getHospitalizationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHospitalizationByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetHospitalizationByPatientSuspense<
  TData = Awaited<ReturnType<typeof getHospitalizationByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHospitalizationByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHospitalizationByPatientSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createHospitalizationByPatient = (
  id: string,
  patientAddressDto: BodyType<PatientAddressDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/patients/${id}/hospitalization`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: patientAddressDto,
      signal,
    },
    options,
  );
};

export const getCreateHospitalizationByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof createHospitalizationByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<PatientAddressDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createHospitalizationByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createHospitalizationByPatient>>,
    { id: string; data: BodyType<PatientAddressDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createHospitalizationByPatient(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<PatientAddressDto> },
    TContext
  >;
};

export type CreateHospitalizationByPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof createHospitalizationByPatient>>
>;
export type CreateHospitalizationByPatientMutationBody = BodyType<PatientAddressDto>;
export type CreateHospitalizationByPatientMutationError = ErrorType<unknown>;

export const useCreateHospitalizationByPatient = <
  TData = Awaited<ReturnType<typeof createHospitalizationByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<PatientAddressDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<PatientAddressDto> }, TContext> => {
  const mutationOptions = getCreateHospitalizationByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const generateCaseNumber = (id: string, options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<string>({ url: `/api/patients/${id}/generate-case-number`, method: 'POST', signal }, options);
};

export const getGenerateCaseNumberMutationOptions = <
  TData = Awaited<ReturnType<typeof generateCaseNumber>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['generateCaseNumber'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateCaseNumber>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return generateCaseNumber(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { id: string }, TContext>;
};

export type GenerateCaseNumberMutationResult = NonNullable<Awaited<ReturnType<typeof generateCaseNumber>>>;

export type GenerateCaseNumberMutationError = ErrorType<unknown>;

export const useGenerateCaseNumber = <
  TData = Awaited<ReturnType<typeof generateCaseNumber>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string }, TContext> => {
  const mutationOptions = getGenerateCaseNumberMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getPatientById = (id: string, options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<PatientDto>({ url: `/api/patients/${id}`, method: 'GET', signal }, options);
};

export const getGetPatientByIdQueryKey = (id: string) => {
  return [`/api/patients/${id}`] as const;
};

export const getGetPatientByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientById>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientById>>> = ({ signal }) =>
    getPatientById(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientById>>>;
export type GetPatientByIdQueryError = ErrorType<unknown>;

export function useGetPatientById<TData = Awaited<ReturnType<typeof getPatientById>>, TError = ErrorType<unknown>>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientById>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getPatientById>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientById<TData = Awaited<ReturnType<typeof getPatientById>>, TError = ErrorType<unknown>>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientById>>, TError, TData>> &
    Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getPatientById>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientById<TData = Awaited<ReturnType<typeof getPatientById>>, TError = ErrorType<unknown>>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientById>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientById<TData = Awaited<ReturnType<typeof getPatientById>>, TError = ErrorType<unknown>>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientById>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPatientByIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientById>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientById>>> = ({ signal }) =>
    getPatientById(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPatientById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientById>>>;
export type GetPatientByIdSuspenseQueryError = ErrorType<unknown>;

export function useGetPatientByIdSuspense<
  TData = Awaited<ReturnType<typeof getPatientById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientById>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientByIdSuspense<
  TData = Awaited<ReturnType<typeof getPatientById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientById>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientByIdSuspense<
  TData = Awaited<ReturnType<typeof getPatientById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientById>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientByIdSuspense<
  TData = Awaited<ReturnType<typeof getPatientById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientById>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientByIdSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const validateCaseNumber = (
  id: string,
  params?: ValidateCaseNumberParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<ValidationResult>(
    { url: `/api/patients/${id}/validate-case-number`, method: 'GET', params, signal },
    options,
  );
};

export const getValidateCaseNumberQueryKey = (id: string, params?: ValidateCaseNumberParams) => {
  return [`/api/patients/${id}/validate-case-number`, ...(params ? [params] : [])] as const;
};

export const getValidateCaseNumberQueryOptions = <
  TData = Awaited<ReturnType<typeof validateCaseNumber>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ValidateCaseNumberParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof validateCaseNumber>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getValidateCaseNumberQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof validateCaseNumber>>> = ({ signal }) =>
    validateCaseNumber(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof validateCaseNumber>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ValidateCaseNumberQueryResult = NonNullable<Awaited<ReturnType<typeof validateCaseNumber>>>;
export type ValidateCaseNumberQueryError = ErrorType<unknown>;

export function useValidateCaseNumber<
  TData = Awaited<ReturnType<typeof validateCaseNumber>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: undefined | ValidateCaseNumberParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof validateCaseNumber>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof validateCaseNumber>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useValidateCaseNumber<
  TData = Awaited<ReturnType<typeof validateCaseNumber>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ValidateCaseNumberParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof validateCaseNumber>>, TError, TData>> &
    Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof validateCaseNumber>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useValidateCaseNumber<
  TData = Awaited<ReturnType<typeof validateCaseNumber>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ValidateCaseNumberParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof validateCaseNumber>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useValidateCaseNumber<
  TData = Awaited<ReturnType<typeof validateCaseNumber>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ValidateCaseNumberParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof validateCaseNumber>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getValidateCaseNumberQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getValidateCaseNumberSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof validateCaseNumber>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ValidateCaseNumberParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof validateCaseNumber>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getValidateCaseNumberQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof validateCaseNumber>>> = ({ signal }) =>
    validateCaseNumber(id, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof validateCaseNumber>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ValidateCaseNumberSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof validateCaseNumber>>>;
export type ValidateCaseNumberSuspenseQueryError = ErrorType<unknown>;

export function useValidateCaseNumberSuspense<
  TData = Awaited<ReturnType<typeof validateCaseNumber>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: undefined | ValidateCaseNumberParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof validateCaseNumber>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useValidateCaseNumberSuspense<
  TData = Awaited<ReturnType<typeof validateCaseNumber>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ValidateCaseNumberParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof validateCaseNumber>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useValidateCaseNumberSuspense<
  TData = Awaited<ReturnType<typeof validateCaseNumber>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ValidateCaseNumberParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof validateCaseNumber>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useValidateCaseNumberSuspense<
  TData = Awaited<ReturnType<typeof validateCaseNumber>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ValidateCaseNumberParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof validateCaseNumber>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getValidateCaseNumberSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMedicationChangeHistory = (
  id: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<TherapyMedicationChangeDto[]>(
    { url: `/api/patients/${id}/therapy/medication-change-history`, method: 'GET', signal },
    options,
  );
};

export const getGetMedicationChangeHistoryQueryKey = (id: string) => {
  return [`/api/patients/${id}/therapy/medication-change-history`] as const;
};

export const getGetMedicationChangeHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedicationChangeHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedicationChangeHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMedicationChangeHistoryQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedicationChangeHistory>>> = ({ signal }) =>
    getMedicationChangeHistory(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMedicationChangeHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMedicationChangeHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getMedicationChangeHistory>>>;
export type GetMedicationChangeHistoryQueryError = ErrorType<unknown>;

export function useGetMedicationChangeHistory<
  TData = Awaited<ReturnType<typeof getMedicationChangeHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedicationChangeHistory>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof getMedicationChangeHistory>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedicationChangeHistory<
  TData = Awaited<ReturnType<typeof getMedicationChangeHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedicationChangeHistory>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof getMedicationChangeHistory>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedicationChangeHistory<
  TData = Awaited<ReturnType<typeof getMedicationChangeHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedicationChangeHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMedicationChangeHistory<
  TData = Awaited<ReturnType<typeof getMedicationChangeHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedicationChangeHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMedicationChangeHistoryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMedicationChangeHistorySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedicationChangeHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedicationChangeHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMedicationChangeHistoryQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedicationChangeHistory>>> = ({ signal }) =>
    getMedicationChangeHistory(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMedicationChangeHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMedicationChangeHistorySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMedicationChangeHistory>>
>;
export type GetMedicationChangeHistorySuspenseQueryError = ErrorType<unknown>;

export function useGetMedicationChangeHistorySuspense<
  TData = Awaited<ReturnType<typeof getMedicationChangeHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedicationChangeHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedicationChangeHistorySuspense<
  TData = Awaited<ReturnType<typeof getMedicationChangeHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedicationChangeHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedicationChangeHistorySuspense<
  TData = Awaited<ReturnType<typeof getMedicationChangeHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedicationChangeHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMedicationChangeHistorySuspense<
  TData = Awaited<ReturnType<typeof getMedicationChangeHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedicationChangeHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMedicationChangeHistorySuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPatientBasicsById = (id: string, options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<PatientBasicsDto>({ url: `/api/patients/${id}/basic`, method: 'GET', signal }, options);
};

export const getGetPatientBasicsByIdQueryKey = (id: string) => {
  return [`/api/patients/${id}/basic`] as const;
};

export const getGetPatientBasicsByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientBasicsById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientBasicsById>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientBasicsByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientBasicsById>>> = ({ signal }) =>
    getPatientBasicsById(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientBasicsById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientBasicsByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientBasicsById>>>;
export type GetPatientBasicsByIdQueryError = ErrorType<unknown>;

export function useGetPatientBasicsById<
  TData = Awaited<ReturnType<typeof getPatientBasicsById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientBasicsById>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getPatientBasicsById>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientBasicsById<
  TData = Awaited<ReturnType<typeof getPatientBasicsById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientBasicsById>>, TError, TData>> &
    Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getPatientBasicsById>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientBasicsById<
  TData = Awaited<ReturnType<typeof getPatientBasicsById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientBasicsById>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientBasicsById<
  TData = Awaited<ReturnType<typeof getPatientBasicsById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientBasicsById>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientBasicsByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPatientBasicsByIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientBasicsById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientBasicsById>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientBasicsByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientBasicsById>>> = ({ signal }) =>
    getPatientBasicsById(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPatientBasicsById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientBasicsByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientBasicsById>>>;
export type GetPatientBasicsByIdSuspenseQueryError = ErrorType<unknown>;

export function useGetPatientBasicsByIdSuspense<
  TData = Awaited<ReturnType<typeof getPatientBasicsById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientBasicsById>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientBasicsByIdSuspense<
  TData = Awaited<ReturnType<typeof getPatientBasicsById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientBasicsById>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientBasicsByIdSuspense<
  TData = Awaited<ReturnType<typeof getPatientBasicsById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientBasicsById>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientBasicsByIdSuspense<
  TData = Awaited<ReturnType<typeof getPatientBasicsById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientBasicsById>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientBasicsByIdSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAnamnesesByPatient = (id: string, options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<GetAnamnesesByPatient200>({ url: `/api/patients/${id}/anamneses`, method: 'GET', signal }, options);
};

export const getGetAnamnesesByPatientQueryKey = (id: string) => {
  return [`/api/patients/${id}/anamneses`] as const;
};

export const getGetAnamnesesByPatientQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnamnesesByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnamnesesByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAnamnesesByPatientQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnamnesesByPatient>>> = ({ signal }) =>
    getAnamnesesByPatient(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnamnesesByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAnamnesesByPatientQueryResult = NonNullable<Awaited<ReturnType<typeof getAnamnesesByPatient>>>;
export type GetAnamnesesByPatientQueryError = ErrorType<unknown>;

export function useGetAnamnesesByPatient<
  TData = Awaited<ReturnType<typeof getAnamnesesByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnamnesesByPatient>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getAnamnesesByPatient>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAnamnesesByPatient<
  TData = Awaited<ReturnType<typeof getAnamnesesByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnamnesesByPatient>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof getAnamnesesByPatient>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAnamnesesByPatient<
  TData = Awaited<ReturnType<typeof getAnamnesesByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnamnesesByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetAnamnesesByPatient<
  TData = Awaited<ReturnType<typeof getAnamnesesByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnamnesesByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAnamnesesByPatientQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAnamnesesByPatientSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnamnesesByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAnamnesesByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAnamnesesByPatientQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnamnesesByPatient>>> = ({ signal }) =>
    getAnamnesesByPatient(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAnamnesesByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAnamnesesByPatientSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAnamnesesByPatient>>>;
export type GetAnamnesesByPatientSuspenseQueryError = ErrorType<unknown>;

export function useGetAnamnesesByPatientSuspense<
  TData = Awaited<ReturnType<typeof getAnamnesesByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAnamnesesByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAnamnesesByPatientSuspense<
  TData = Awaited<ReturnType<typeof getAnamnesesByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAnamnesesByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAnamnesesByPatientSuspense<
  TData = Awaited<ReturnType<typeof getAnamnesesByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAnamnesesByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetAnamnesesByPatientSuspense<
  TData = Awaited<ReturnType<typeof getAnamnesesByPatient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAnamnesesByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAnamnesesByPatientSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPatientAddresses = (id: string, options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<PatientAddressDto[]>({ url: `/api/patients/${id}/addresses`, method: 'GET', signal }, options);
};

export const getGetPatientAddressesQueryKey = (id: string) => {
  return [`/api/patients/${id}/addresses`] as const;
};

export const getGetPatientAddressesQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientAddresses>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientAddresses>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientAddressesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientAddresses>>> = ({ signal }) =>
    getPatientAddresses(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientAddresses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientAddresses>>>;
export type GetPatientAddressesQueryError = ErrorType<unknown>;

export function useGetPatientAddresses<
  TData = Awaited<ReturnType<typeof getPatientAddresses>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientAddresses>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getPatientAddresses>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientAddresses<
  TData = Awaited<ReturnType<typeof getPatientAddresses>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientAddresses>>, TError, TData>> &
    Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getPatientAddresses>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientAddresses<
  TData = Awaited<ReturnType<typeof getPatientAddresses>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientAddresses>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientAddresses<
  TData = Awaited<ReturnType<typeof getPatientAddresses>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientAddresses>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientAddressesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPatientAddressesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientAddresses>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientAddresses>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientAddressesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientAddresses>>> = ({ signal }) =>
    getPatientAddresses(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPatientAddresses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientAddressesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientAddresses>>>;
export type GetPatientAddressesSuspenseQueryError = ErrorType<unknown>;

export function useGetPatientAddressesSuspense<
  TData = Awaited<ReturnType<typeof getPatientAddresses>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientAddresses>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientAddressesSuspense<
  TData = Awaited<ReturnType<typeof getPatientAddresses>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientAddresses>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientAddressesSuspense<
  TData = Awaited<ReturnType<typeof getPatientAddresses>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientAddresses>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientAddressesSuspense<
  TData = Awaited<ReturnType<typeof getPatientAddresses>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientAddresses>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientAddressesSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
